<template lang="pug">
modal#delete-developer-client-modal(
  :noFooter='true'
  :title='$t("modal.creatingAppInfo.title")'
  @process='closeModal'
  ref='modal'
)
  .text-center
    p.text-start {{ $t('modal.creatingAppInfo.message1') }}
    p.text-start {{ $t('modal.creatingAppInfo.message2') }}

    img.mt-4.mb-3(
      alt='developer-delete-warning'
      src='/img/ilustrations/application-warning.svg'
    )

  .modal-footer.p-0.d-flex.justify-content-end
    button#buttonColor.btn.btn-primary(@click='closeModal' type='button')
      | {{ $t('modal.creatingAppInfo.okButton') }}
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'CreatingAppInfoModal',
  components: {
    Modal,
  },
  methods: {
    closeModal() {
      this.$emit('closed');
      this.$refs.modal.close();
    },
  },
};
</script>
